// Error components must be Client Components
"use client";

import styling from "@/app/global-error.module.scss";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <>
      <div className={styling.errorContainer}>
        <h2>Oh no! Something went wrong! 🌶️🔥</h2>
        <p>
          Looks like we&apos;ve hit a spicy snag! Here&apos;s what happened:
        </p>
        <p className={styling.errorMessage}>{error.message}</p>
        <p>
          But don&apos;t worry, our team is sprinkling some magic chili powder
          on it!
        </p>
        <button className={styling.retryButton} onClick={reset}>
          Give it another shot!
        </button>
      </div>
    </>
  );
}
